import ApiService from '@/services/api'
import { defineStore } from 'pinia'

const ENDPOINT = '/equipments/'
const ITEM_ID  = 'equ_id'

export const useEquipmentStore = defineStore('equipments', {
  state: () => ({
    item: { equ_customfields: {}, equ_sta_id: 'GEN01', equ_typ_id: 'EQU01' },
    itemList: [],
    metaItems: null
  }),
  getters: {},
  actions: {
    fetchItem (id, options) {
      return new Promise((resolve, reject) => {
        options = (options) ? '/' + options : ''
        if (id && id > 0) {
          ApiService.get(ENDPOINT + id + options).then((response) => {
            if (!response.data.data.equ_customfields || Object.prototype.toString.call(response.data.data.equ_customfields) === '[object Array]') {
              response.data.data.equ_customfields = {}
            }
            this.SET_ITEM(response.data.data)
            resolve(this.item)
          }).catch((error) => { reject(error) })
        } else {
          this.RESET_ITEM()
          resolve(this.item)
        }
      })
    },
    fetchItems (options) {
      return new Promise((resolve, reject) => {
        ApiService.get(ENDPOINT + (options || '')).then((response) => {
          this.metaItems = response.data.meta
          if (Object.prototype.toString.call(response.data.data) === '[object Array]') {
            this.SET_ITEMS(response.data.data)
          }
          resolve('resolved')
        }).catch((error) => { reject(error) })
      })
    },
    storeItem () {
      return new Promise((resolve, reject) => {
        ApiService.post(ENDPOINT, this.item).then((response) => {
          this.SET_ITEM(response.data.data)
          resolve(this.item)
        }).catch((error) => { reject(error) })
      })
    },
    updateItem () {
      return new Promise((resolve, reject) => {
        ApiService.put(ENDPOINT + this.item[ITEM_ID], this.item).then((response) => {
          this.SET_ITEM(response.data.data)
          resolve(this.item)
        }).catch((error) => { reject(error) })
      })
    },
    destroyItem (id) {
      return new Promise((resolve, reject) => {
        this.item[ITEM_ID] = (id) ? id : this.item[ITEM_ID]
        ApiService.delete(ENDPOINT + this.item[ITEM_ID]).then(() => {
          resolve('resolved')
        }).catch((error) => { reject(error) })
      })
    },
    //***************************MUTATIONS ***************************************/
    SET_ITEM (item) {
      if (item && (!item.equ_customfields || Object.prototype.toString.call(item.equ_customfields) === '[object Array]')) {
        item.equ_customfields = {}
      }
      this.item = item
    },
    SET_ITEMS (itemList) {
      itemList.forEach(element => {
        element.equ_customfields = (!element.equ_customfields) ? {} : element.equ_customfields
      })
      this.itemList = itemList
    },
    RESET_ITEM () { this.item = { equ_customfields: {}, equ_sta_id: 'GEN01', equ_typ_id: 'EQU01' } }
  }
})
